import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { isEmpty, sortBy } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import {
  uploadMultiPartFiles,
  getARReasonCodeSelectionConfig,
  saveOutputTemplateByType,
  getOutputTemplateByType,
} from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { OpenWriteOffSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportOpenWriteOff, sortOpenWriteOff } from '../../constants';
import { getOpenWriteOff, getAllOpenWriteOff } from '../../actions';
import { makeGetListOpenWriteOff, makeGetListAllOpenWriteOff } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class OpenWriteOff extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listOpenWriteOff: [],
    listReasonOptions: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listOpenWriteOff: props.listOpenWriteOff,
      totalCount: getPageTotalCount({ ...state, items: props.listOpenWriteOff }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetWriteOffReport },
      getARReasonCodeSelectionConfig,
    } = this.props;
    if (modeGetWriteOffReport) {
      this.doGetReportOpenWriteOff();
      this.doGetOutputTemplateByType();
      getARReasonCodeSelectionConfig('', ({ success, data }) => {
        if (success && data) {
          const listReasonOptions = data
            .filter(dt => !!dt.customReasonCode)
            .map(val => {
              return { label: val.customReasonCode, value: val.customReasonCode };
            });
          this.setState({ listReasonOptions: listReasonOptions ? sortBy(listReasonOptions) : [] });
        }
      });
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetReportOpenWriteOff();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doGetReportOpenWriteOff());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetReportOpenWriteOff());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetReportOpenWriteOff();
    });
  };

  doGetReportOpenWriteOff = () => {
    const { filter, page, size, sorted } = this.state;
    const { getOpenWriteOff } = this.props;
    const payload = {
      page: page + 1,
      size,
      filter,
      sort: !isEmpty(sorted) ? sortOpenWriteOff[sorted.sortCol][sorted.sortDir] : null,
    };
    this.setState({ isSearching: true });
    getOpenWriteOff(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAllOpenWriteOff = cb => {
    const { filter, sorted } = this.state;
    const { getAllOpenWriteOff } = this.props;
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter,
      sort: !isEmpty(sorted) ? sortOpenWriteOff[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllOpenWriteOff(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAllOpenWriteOff(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllOpenWriteOff, t } = this.props;
        convertJson2Pdf({
          data: listAllOpenWriteOff,
          t,
          title: t('reportPage:sidebar.openWriteOff').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.openWriteOff')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
          fontSize: 4,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAllOpenWriteOff(() => {
      const { listAllOpenWriteOff, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'GET_WRITEOFF_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.openWriteOff')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.openWriteOff')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllOpenWriteOff,
            t,
            columns: tableColumnsOutput,
            listOptionFields: {
              recurringUnit: 'recurringUnit',
              arLevel: 'arLevel',
              taxTreatment: 'taxRule',
              arCrDrType: 'CRDRType',
              accountType: 'accountType',
              paymentMethod: 'paymentMethod',
            },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllOpenWriteOff,
          t,
          title: t('reportPage:sidebar.openWriteOff').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.openWriteOff')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
          fontSize: 4,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.openWriteOff')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('OPEN_WRITEOFF_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportOpenWriteOff,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listOpenWriteOff,
      listReasonOptions,
      emails,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllOpenWriteOff,
      t,
      permissions: { modeGetWriteOffReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetWriteOffReport) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.openWriteOff') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.openWriteOff')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <OpenWriteOffSearchForm
                  keyOptionInject="customReason"
                  optionsInject={listReasonOptions}
                  onSubmit={this.onHandleSubmitSearch}
                />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.openWriteOff').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllOpenWriteOff,
                          t,
                          title: t('reportPage:sidebar.openWriteOff').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.openWriteOff')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listOpenWriteOff}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={listOpenWriteOff && listOpenWriteOff.length ? listOpenWriteOff : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

OpenWriteOff.propTypes = {
  getAllOpenWriteOff: PropTypes.func,
  getOpenWriteOff: PropTypes.func,
  listAllOpenWriteOff: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.objectOf(PropTypes.any)]),
};

OpenWriteOff.defaultProps = {
  getAllOpenWriteOff: () => {},
  getOpenWriteOff: () => {},
  listAllOpenWriteOff: [],
};

const mapStateToProps = createStructuredSelector({
  listOpenWriteOff: makeGetListOpenWriteOff() || [],
  listAllOpenWriteOff: makeGetListAllOpenWriteOff() || [],
});

export default withTranslation('common')(
  connect(mapStateToProps, {
    getOpenWriteOff,
    getAllOpenWriteOff,
    getARReasonCodeSelectionConfig,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
  })(OpenWriteOff)
);
